<template>
  <div class="v-announcement">
    <sheet>
      <loading v-if="tabLoading" />
      <tabs :config="tabsConfig" v-model:activeKey="activeTabKey" v-else />

      <loading v-if="articlesLoading" />
      <div class="article-wrap" v-else>
        <brief-article :articles="articles" type="announcement" />
      </div>

      <div class="pagination-wrap">
        <pagination :pager="pager" @handlePagination="handlePagination" />
      </div>
    </sheet>
  </div>
</template>
<script>
import {
  defineComponent, ref, reactive, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Tabs from '@/components/Global/Tabs.vue';
import BriefArticle from '@/components/Global/BriefArticle.vue';
import Pagination from '@/components/Global/Pagination.vue';
import { getViewArticlesAPI } from '@/api/articles';
import { getIndexCategoriesAPI } from '@/api/categories';
import useRequest from '@/hooks/useRequest';
import useAsyncDialog from '@/hooks/useAsyncDialog';

export default defineComponent({
  name: 'Announcements',
  components: {
    Tabs,
    BriefArticle,
    Pagination,
  },
  setup() {
    const { asyncDialog } = useAsyncDialog();
    const route = useRoute();
    const router = useRouter();
    const articles = ref([]);
    const activeTabKey = ref('news');
    const tabsConfig = ref([]);

    const pager = reactive({
      pageIndex: Number(route.query?.pageIndex) || 1,
      totalPage: 10,
    });

    const { response, request, isLoading: tabLoading } = useRequest(getIndexCategoriesAPI);
    request({ type: 'news' });

    const {
      response: articlesResponse,
      request: articlesRequest,
      isLoading: articlesLoading,
    } = useRequest(getViewArticlesAPI);

    const getViewArticles = async (res) => {
      const {
        result,
        status,
      } = res.value;

      if (!status || result.data.length === 0) {
        asyncDialog({
          desc: '尚無資料',
        });
      }

      if (status) {
        articles.value = result.data;
        pager.totalPage = result.pageCount;

        return;
      }
      articles.value = [];
    };

    const handlePagination = (targetPage) => {
      pager.pageIndex = targetPage;

      router.push({
        name: 'announcements',
        query: {
          pageIndex: pager.pageIndex,
          tab: route.query.tab,
        },
      });
      articlesRequest({ ...pager, type: 'news', category: activeTabKey.value });
    };

    const getIndexCategories = (res) => {
      const {
        result: { data },
      } = res.value;

      tabsConfig.value = data.map((item) => ({
        label: item.name,
        key: String(item.id),
      }));

      activeTabKey.value = route.query.tab || data[0].id;

      router.push({
        name: 'announcements',
        query: {
          pageIndex: pager.pageIndex,
          tab: route.query.tab || data[0].id,
        },
      });

      pager.pageIndex = 1;
    };

    watch(response, () => {
      getIndexCategories(response);
    });

    watch(articlesResponse, () => {
      getViewArticles(articlesResponse);
    });

    watch(
      activeTabKey,
      () => {
        pager.pageIndex = 1;

        router.push({
          name: 'announcements',
          query: {
            pageIndex: pager.pageIndex,
            tab: activeTabKey.value,
          },
        });

        articlesRequest({
          ...pager, pageIndex: 1, type: 'news', category: activeTabKey.value,
        });
      },
    );

    return {
      articles,
      activeTabKey,
      tabsConfig,

      pager,
      handlePagination,
      tabLoading,
      articlesLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/tableWrap.scss';
</style>
